@import '../../styles/typography.scss';
// TODO: reduce imports or make a utility for links with chevrons

:host {
  display: block;
  --triangleColor: #2b6480;
}

.fls-hero {
  overflow: hidden;

  .display-3 {
    font-size: clamp(2.1875rem, -3.4047rem + 9.1205vw, 4rem);
    font-weight: 600;

    @media screen and (min-width: 768px) {
      text-wrap: balance;
    }
  }

  .lead {
    font-size: clamp(1rem, 0.1922rem + 1.3029vw, 1.25rem) !important;
    font-weight: normal;
    line-height: clamp(1.625rem, 0.1922rem + 1.3029vw, 1.875rem);
    text-wrap: pretty; /* discourage orphans */

    & > *:last-child {
      margin-bottom: 0;
    }
  }
}

.fls-hero-container {
  display: grid;
  position: relative;
  grid-template: 'container';
}

.fls-hero-container > .row {
  grid-area: container;
}

h1 em {
  color: var(--bs-secondary, #a6ddef);
}

.fls-hero-photo {
  margin-bottom: -40px;

  @media screen and (min-width: 768px) {
    // margin-left: calc(-20vw + 30px);
  }

  @media screen and (min-width: 1100px) {
    // margin-left: auto;
  }

  & img {
    max-width: 106vw;
    margin-left: -100px;
    transform: translateX(22px);

    @media screen and (min-width: 768px) {
      transform: none;
      margin-left: 0;
    }
  }
}

.fls-hero-photo img {
  object-fit: contain;
  display: block;
  width: 100%;
  height: auto;

  width: 418px;
  margin-bottom: -108px;

  @media screen and (min-width: 768px) {
    width: 105%;
    margin-bottom: 1px;
    transform: translateX(-110px);
  }

  @media screen and (min-width: 1300px) {
    transform: translateX(-250px);
  }
}

.fls-hero-background {
  margin-left: -12px;
  margin-right: -12px;
}

.fls-hero-background svg {
  object-fit: contain;
  display: block;
  width: 100%;
  height: 100%;
  // overflow: visible;

  // stacked svgs if multiple backgrounds
  & + svg {
    position: absolute;
  }
}

// hide photo and background until photo has fully loaded
.fls-hero.is-loading {
  .fls-hero-photo img,
  .fls-hero-background svg {
    opacity: 0;
  }
}

.fls-hero-background .background-mobile {
  margin-left: -10vw;

  @include media-breakpoint-up(sm) {
    margin-left: 0;
  }

  svg {
    max-height: 340px;
  }
}

.fls-hero-background .background-mobile svg[width='100%'] {
  width: 50vw;
  overflow: visible;
}

.background-shapes {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.fls-hero-triangle {
  position: absolute;
  z-index: var(--triangleZ, 5);
  top: var(--triangleTop, 90%);
  left: var(--triangleLeft, -10%);
  bottom: var(--triangleBottom, auto);
  right: var(--triangleRight, auto);
  aspect-ratio: 1/1;
  background-color: var(--triangleColor, #2b6480);
  clip-path: polygon(0% 0, 100% 100%, 0 100%);
  width: var(--triangleSize, var(--triangleWidth, auto));
  height: var(--triangleSize, var(--triangleHeight, 49%));
}

.fls-hero-triangle-1 {
  top: auto;
  left: auto;
  bottom: -1px;
  right: 0;
  width: var(--triangleSize, var(--triangleWidth, auto));
  height: var(--triangleSize, var(--triangleHeight, 49%));
}

.fls-hero-triangle-2 {
  left: 100%;
  top: 0;
  transform: scaleY(-1) scaleX(-1);
  background-color: var(--triangleColor, #2b6480);
  width: var(--triangleSize, var(--triangleWidth, auto));
  height: var(--triangleSize, var(--triangleHeight, 51%));
}

.fls-hero-triangle.flip-h {
  clip-path: polygon(100% 0, 100% 100%, 0 100%);
}

.fls-hero-foreground {
  z-index: 3;
}

.fls-hero-breadcrumb {
  margin-left: -1rem;
  a {
    color: var(--bs-white, #fff);
    @extend .fls-icon-chevron-left;
    &:before {
      margin-right: 0.5rem;
      //  background-image: url("data:image/svg+xml, <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6.91 12'><path d='M0,11a1,1,0,0,1-.673-.261A1,1,0,0,1-.739,9.326L3.2,5-.739.674A1,1,0,0,1-.674-.739,1,1,0,0,1,.739-.674L5.91,5,.739,10.674A1,1,0,0,1,0,11Z' fill='%23a6ddef'/></svg>");
    }
    &:hover {
      color: var(--bs-white, #fff);
    }
  }
}

.fls-hero[data-layout='default'] {
  .fls-hero-background svg {
    overflow: visible !important;

    .svg--medium_angle {
      transform: translateX(-20vw);

      @include media-breakpoint-up(md) {
        transform: translateX(-30px);
      }
    }
  }

  .fls-hero-background {
    opacity: 0.5;

    @include media-breakpoint-up(md) {
      opacity: 1;
    }
  }
  .background-shapes {
    display: block !important;
  }

  .fls-hero-triangle-1 {
    --triangleHeight: 150px;

    @include media-breakpoint-up(md) {
      transform: translateX(30px);
      --triangleHeight: 150px;
    }

    @include media-breakpoint-up(lg) {
      transform: translateX(20px);
      --triangleHeight: 80%;
    }

    @include media-breakpoint-up(xxl) {
      transform: translateX(107px);
      --triangleHeight: 100%;
    }
  }
  .fls-hero-triangle-2 {
    --triangleHeight: 0%;
  }
}

.fls-hero[data-layout='home'] {
  @media (max-width: 379.98px) {
    // fit 'immunization' on first line for smaller devices
    .display-3 {
      font-size: 2rem;
    }
  }

  @include media-breakpoint-up(lg) {
    /* reduce image/container size on vertical resize */
    .fls-hero-container,
    .fls-hero-container > .row,
    .fls-hero-photo img {
        max-height: clamp(540px, 70vh, 611px);
    }

    /* reduce font size on vertical resize */
    .fls-hero .display-3 {
        font-size: clamp(3.375rem, clamp(2.1875rem, -3.4047rem + 9.1205vw, 4rem), -3.0047rem + 13.25205vh);
    }
  }

}

.fls-hero[data-layout='landing'] {
  .fls-hero-triangle-2 {
    --triangleColor: #2b6480 !important;
  }

  .fls-hero-triangle-skew {
    clip-path: polygon(130% 0, 100% 100%, 0 100%);
    --triangleColor: var(--bs-tertiary);
    height: 65%;
    max-height: 30vw;

    @include media-breakpoint-up(md) {
      max-height: none;
    }
  }

  .fls-hero-photo {
    margin-bottom: 0;
  }

  .fls-hero-photo img {
    object-fit: contain;
    display: block;
    width: 100%;
    height: 100%;
    // TODO: Refactor magic numbers to get the image to scale with container
    max-width: 80vw;
    margin-bottom: -15%;
    padding-inline: 0;
    // transform: translateX(9vw);
    transform: translate(9vw, -2rem);
    margin-left: 0;

    @include media-breakpoint-up(sm) {
      max-width: 63vw;
      margin-bottom: -9%;
    }

    @include media-breakpoint-up(md) {
      // transform: translateX(0);
      transform: translate(0, 0);
      margin-bottom: 0;
      padding-inline: 0;
      height: auto;
    }

    @include media-breakpoint-up(xl) {
      transform: translateX(-170px);
    }

    @include media-breakpoint-up(xxl) {
      transform: translateX(-120px);
    }
  }

  .fls-hero-background svg {
    height: 100%;
  }

  .fls-hero-background .background-desktop {
    @include media-breakpoint-up(md) {
      transform: translateX(0);
    }

    @include media-breakpoint-up(lg) {
      // transform: translateX(-170px);
    }
  }

  .background-shapes.d-none {
    display: block !important;
  }

  @include media-breakpoint-up(lg) {
    /* reduce image/container size on vertical resize */
    .fls-hero-container,
    .fls-hero-container > .row,
    .fls-hero-photo img {
        max-height: clamp(420px, 50vh, 504px);
    }

    /* reduce font size on vertical resize */
    .display-3 {
        font-size: clamp(3.375rem, clamp(2.1875rem, -3.4047rem + 9.1205vw, 4rem), -3.0047rem + 11.5205vh);
    }
  }
}
